import { Component, OnInit, Inject, NgZone, ViewChild, ChangeDetectorRef, HostListener } from '@angular/core';

import { HttpClient } from '@angular/common/http';
//import data_settingMAO from '../../../assets/json/MaoProject.json';
import data_settingMAO from '../../../../assets/json/MaoProject.json';
import { UsersAuthService } from 'src/app/users-auth.service';
import { ApiVideoService } from 'src/app/Services/api-video.service';
import { ApiService } from 'src/app/Services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from 'src/app/Services/utility.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Video } from 'src/app/Admin/video-management/video';

declare const $: any;

const hostGeneral = data_settingMAO.RestApi;
const maoCdnEndpoint = data_settingMAO.MaoCdnEndpoint;

@Component({
  selector: 'videos-navbar',
  templateUrl: './videos-navbar.component.html',
  styleUrls: ['./videos-navbar.component.css']
})
export class VideosNavbarComponent implements OnInit {
  paramDeveloper: string = '';
  myItemSession: any;
  video: Video = new Video();
  isVideoPlaying: boolean = false;
  sanitizedVideoURL: SafeResourceUrl;
  RoleID: number;
  constructor(
    private apiService: ApiService, private http: HttpClient, private ngZone: NgZone,
    private route: ActivatedRoute, private _utilityService: UtilityService, private apiVideoService: ApiVideoService,
    public sanitizer: DomSanitizer
  ) {

    this.paramDeveloper = "";
    this.route.queryParams.subscribe(params => {
      this.paramDeveloper = params['developer'];
    });

  }

  //   videoList : any =  [
  //     {
  //       VideoID: 1,
  //       Title: 'Introduction to MyAdOptimizer',
  //       Description: 'A brief introduction to the features and functionalities of MyAdOptimizer.',
  //       Duration: 10,
  //       CategoryName: 'Getting Started',
  //       ThumbnailURL: 'https://cdn.myadoptimizer.com/maojsfiles/images/ThumbnailVideo_000004_30105a07-d134-409b-8e4e-2827d3bd7e7a.jpg',
  //       URL: 'https://go.screenpal.com/watch/cZiTqjVPzwu' // Añadir la URL del video
  //     },
  //     {
  //       VideoID: 2,
  //       Title: 'Setting Up Your First Campaign',
  //       Description: 'Step-by-step guide to setting up your first advertising campaign on MyAdOptimizer.',
  //       Duration: 15,
  //       CategoryName: 'Campaigns',
  //       ThumbnailURL: 'https://cdn.myadoptimizer.com/maojsfiles/images/ThumbnailVideo_000004_30105a07-d134-409b-8e4e-2827d3bd7e7a.jpg',
  //       URL: 'https://www.youtube.com/watch?v=nlz8yw48Uks' // Añadir la URL del video
  //     },
  //     {
  //       VideoID: 3,
  //       Title: 'Analyzing Campaign Performance',
  //       Description: 'Learn how to analyze dashboard.Learn how to analyze dashboardLearn how to analyze dashboard...',
  //       Duration: 12,
  //       CategoryName: 'Analytics',
  //       ThumbnailURL: 'https://cdn.myadoptimizer.com/maojsfiles/images/ThumbnailVideo_000003.jpg',
  //       URL: 'https://www.youtube.com/watch?v=exampleID3' // Añadir la URL del video
  //     },
  //     {
  //       VideoID: 4,
  //       Title: 'Advanced Features Overview',
  //       Description: 'Explore the advanced features of MyAdOptimizer to maximize your advertising strategy.',
  //       Duration: 20,
  //       CategoryName: 'Advanced Features',
  //       ThumbnailURL: 'https://cdn.myadoptimizer.com/maojsfiles/images/ThumbnailVideo_000004.jpg',
  //       URL: 'https://vimeo.com/exampleID4' // Añadir la URL del video
  //     },
  //     {
  //       VideoID: 5,
  //       Title: 'Troubleshooting Common Issues',
  //       Description: 'A guide to troubleshooting common issues you may encounter while using MyAdOptimizer.',
  //       Duration: 8,
  //       CategoryName: 'Support',
  //       ThumbnailURL: 'https://cdn.myadoptimizer.com/maojsfiles/images/ThumbnailVideo_000005.jpg',
  //       URL: 'https://www.youtube.com/watch?v=exampleID5' // Añadir la URL del video
  //     }
  // ];

  videoList: any = [];

  ngOnInit() {
    this.myItemSession = localStorage.getItem("SessionMAO");
    this.myItemSession = JSON.parse(this.myItemSession);
    this.RoleID = this.myItemSession.RoleID;
    this.getVideoList();
  }

  getThumbnailURL(video: any): string {
    if (video.ThumbnailURL) {
      return `${maoCdnEndpoint}/maojsfiles/images/${video.ThumbnailURL}`;
    } else {
      return 'assets/img/thumbnails/not-available.png'; // Como fallback inicial
    }
  }

  onImageError(event: Event, video: Video) {
    const element = event.target as HTMLImageElement;
    element.src = 'assets/img/thumbnails/not-available.png'; // Ruta a la imagen de 'no disponible'
    //video.ThumbnailURL = 'assets/img/thumbnails/not-available.png'; // O actualiza el campo si quieres cambiar permanentemente
  }

  getVideoList(): void {
    this.videoList = [];

    //this.apiVideoService.getCategoriesVideoList()
    var param = this.paramDeveloper;

    this.apiVideoService.getVideoList()
      .then((results: any) => {
        let resultsDB = results;
        if (resultsDB.code == 0) {
          if (resultsDB != undefined && resultsDB.Value.length > 0) {
            var videosByRole = resultsDB.Value;
            this.videoList = videosByRole.filter(v => v.RoleID == this.RoleID);
            if (param == '1') {
              console.log("videoList: ")
              console.log(JSON.stringify(this.videoList))
              console.log('Role: ' + this.RoleID);

            }
          }
        }
        else {
          this.videoList = [];
        }
      })
      .catch(err => {
        if (this.paramDeveloper == '1') {

          return;
        }
      });
  }


  isMobileMenu() {
    if ($(window).width() > 990) {
      return false;
    }
    return true;
  };


  openModal() {
    let element = $('#UserGuideModal');
    element.modal('show');

    this.removeBackdrop();
  }

  removeBackdrop() {
    var y = document.getElementsByClassName("modal-backdrop");
    y[0].classList.remove('modal-backdrop')
  }


  // closeVideo() {
  //   this.isVideoPlaying = false;
  //   this.sanitizedVideoURL = '';
  // }

  closeVideo() {
    this.isVideoPlaying = false;
    this.sanitizedVideoURL = '';

    // Restaura el ancho original del sidebar al cerrar el modal
    if (this.isMobileMenu()){
      const sidebar = document.querySelector('.sidebar') as HTMLElement;
      const sideWraper = document.querySelector('.sidebar-wrapper') as HTMLElement;
      
      if (sidebar) {
          sidebar.style.width = ''; // Restaura el valor predeterminado de CSS
          sidebar.style.transform = ''; // Restaura el valor por defecto (sin transformación)
          sidebar.style.pointerEvents = ''; // Reactiva la interacción con el sidebar
          sideWraper.style.width = '';
          sideWraper.style.transform = ''; // Restaura el valor por defecto (sin transformación)
          sideWraper.style.pointerEvents = ''; // Reactiva la interacción con el sidebar
      }
    }
}



  sanitizeURL(url: string): SafeResourceUrl {
    const videoURL = this.transformToEmbedURL(url);
    return this.sanitizer.bypassSecurityTrustResourceUrl(videoURL);
  }

  transformToEmbedURL(url: string): string {
    if (url.includes('youtube.com')) {
      return url.replace('watch?v=', 'embed/');
    } else if (url.includes('vimeo.com')) {
      return url.replace('vimeo.com', 'player.vimeo.com/video');
    } else if (url.includes('screenpal.com')) {
      return url.replace('watch', 'embed');
    }
    return url;
  }



  playVideoDemo(videoReceived) {

    this.video = videoReceived;
    if (this.video.URL.includes('go.screenpal.com')) {
      // Manejo específico para videos de go.screenpal.com
      const videoID = this.extractVideoID(this.video.URL);
      if (videoID) {
        this.isVideoPlaying = true;
        this.sanitizedVideoURL = this.sanitizer.bypassSecurityTrustResourceUrl(`https://go.screenpal.com/player/${videoID}`);
      } else {
        this.isVideoPlaying = false;
        alert('This video URL cannot be embedded.');
      }
    } else if (this.video.URL.includes('youtube.com') || this.video.URL.includes('youtu.be')) {
      // Manejo para videos de YouTube
      const videoID = this.extractYouTubeVideoID(this.video.URL);
      if (videoID) {
        this.isVideoPlaying = true;
        this.sanitizedVideoURL = this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${videoID}`);
      } else {
        this.isVideoPlaying = false;
        alert('This YouTube video URL cannot be embedded.');
      }
    } else {
      // Manejo para otros videos (otros servicios)
      this.isVideoPlaying = true;
      this.sanitizedVideoURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.video.URL);

    }

    if (this.isMobileMenu()) {
      const sidebar = document.querySelector('.sidebar') as HTMLElement;
      const sideWraper = document.querySelector('.sidebar-wrapper') as HTMLElement;
      if (sidebar) {
        sidebar.style.width = '100%';
        sidebar.style.transform = 'none';
        sidebar.style.pointerEvents = 'none'; // Desactiva la interacción con el sidebar
        sideWraper.style.width='100%';

      }
    }
  }

  extractYouTubeVideoID(url: string): string | null {
    let videoID = null;
    const youtubeRegex = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(youtubeRegex);
    if (match && match[1]) {
      videoID = match[1];
    }
    return videoID;
  }


  extractVideoID(url: string): string | null {
    const regex = /watch\/([a-zA-Z0-9_-]+)/;
    const match = url.match(regex);
    return match ? match[1] : null;
  }



}
